<div class="fx-row fx-wrap align-items-start justify-content-start" *ngIf="!loading && done && !noDocs">
  <div class="fx-flex-100">
    <span class="title bold dark">Your cases</span>
  </div>
  <div class="fx-flex-25 p-8 border-box" *ngFor="let case of cases.docs">
    <app-case-card [case]="case" [showState]="true"></app-case-card>
  </div>
</div>
<app-empty-placeholder *ngIf="!loading && done && noDocs" class="fx-flex" [offset]="125"
  [title]="'HOME.CASE_OPERATOR_NO_CASES'" [message]="'HOME.CASE_OPERATOR_NO_CASES_MESSAGE'"></app-empty-placeholder>